"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function isRequiredBoolean() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isValid = value === true ? true : false;
  var message = isValid ? '' : 'Esse campo é obrigatório';
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(isRequiredBoolean);